import { Clock, LogOut } from 'lucide-react'
import { useI18n } from '../i18n'

import { OverlayPortal } from './ModalPortal'
import { Z_SECURITY } from '../utils/zLayers'
export default function IdleTimeoutModal({ secondsLeft, onStayLoggedIn, onLogout, willLock = false }) {
  const { t } = useI18n()
  return (
    <OverlayPortal>
    <div className="fixed inset-0 flex items-center justify-center bg-black/60 px-6" style={{ zIndex: Z_SECURITY }}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center">
        {/* Icon */}
        <div className="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-4">
          <Clock className="w-7 h-7 text-amber-500" />
        </div>

        {/* Title */}
        <h2 className="text-lg font-bold text-slate-900 mb-1">
          {willLock ? 'Session Lock' : 'Session Timeout'}
        </h2>

        {/* Message */}
        <p className="text-sm text-slate-500 mb-1">
          {willLock
            ? "For your security, your session will lock. You'll just need your PIN to resume."
            : "For your security, you'll be logged out due to inactivity."}
        </p>

        {/* Countdown */}
        <div className="my-4">
          <span className="text-3xl font-bold text-brand-navy tabular-nums">
            {secondsLeft}
          </span>
          <span className="text-sm text-slate-400 ml-1.5">seconds</span>
        </div>

        {/* Actions */}
        <div className="space-y-2.5">
          <button
            onClick={onStayLoggedIn}
            className="w-full py-3 bg-[#46A8F9] text-white font-semibold rounded-xl hover:bg-[#3a96e0] active:bg-[#2e84cc] transition-colors text-sm"
          >
            {t('security.stayLoggedIn')}
          </button>
          <button
            onClick={onLogout}
            className="w-full py-3 text-slate-500 font-medium rounded-xl hover:bg-slate-50 active:bg-slate-100 transition-colors text-sm flex items-center justify-center gap-2"
          >
            <LogOut className="w-4 h-4" />
            {t('security.logOutNow', 'Log Out Now')}
          </button>
        </div>
      </div>
    </div>
    </OverlayPortal>
  )
}
